import type {
  UiAction,
} from '../types';

export const triggerAnalytic = (
  eventKey: string,
  attrs?: any,
): UiAction => ({
  type: 'GC_ANALYTICS',
  eventKey,
  attrs,
});
